import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Badge, Button } from './ui';
import { scrollToPurchaseSection } from '../utils';
type HeroProps = {
  onPurchaseRequest?: () => void;
};
export function Hero({
  onPurchaseRequest
}: HeroProps) {
  const handlePurchaseClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    // La sección de compra se monta de forma diferida: si todavía no existe,
    // se delega en App para montarla y desplazarse en cuanto esté disponible.
    if (!scrollToPurchaseSection()) {
      onPurchaseRequest?.();
    }
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-14" data-mp="sai535t46z7u">
      {/* Background glow */}
      <div className="hero-backdrop absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-200/40 rounded-full blur-[120px] pointer-events-none" data-id="element-15" data-mp="nbosdflnjc8q"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-16" data-mp="381nvnbrr4x50">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-17" data-mp="3j7zh7oa6s2jb">
          <Sparkles className="w-6 h-6 text-brand-500" aria-hidden="true" data-id="element-18" data-mp="3j6g1pzwctvil" />
          <span className="text-brand-600 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-19" data-mp="3o73pmcpadw8l">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-ink mb-4 tracking-tight text-[23px]" data-id="element-20" data-mp="3e8wismopoukb">
          ¿ANSIEDAD? ¿INSOMNIO? ¿SENTÍS QUE TU CUERPO VIVE EN ESTADO DE ALERTA?
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-21" data-mp="358hmksa7lv21">
          <div className="hero-mockup-glow absolute inset-0 bg-lav-200/50 blur-[80px] rounded-full pointer-events-none" data-id="element-22" data-mp="35aud3tu19dqp"></div>
          <img src="https://cdn.magicpatterns.com/uploads/3a8Cyh3ZTrLTaikqwNpacy/Ajuste_a_420x420.png" alt="Megapack Regulación del Sistema Nervioso, con seis tomos y cinco bonos incluidos" className="relative z-10 w-full max-w-lg h-auto mix-blend-multiply pl-[45px] pr-[45px]" width={420} height={420} style={{
          aspectRatio: '1 / 1'
        }} loading="eager" fetchPriority="high" decoding="async" data-id="element-23" data-mp="2viy3pmmhy176" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-24" data-mp="id00cg3n7mjd">
          Quizás el problema no sea tu mente. Quizás sea un sistema nervioso
          atrapado en modo supervivencia. Aprendé a regularlo con un plan guiado
          de 30 días y empezá a recuperar la calma desde el primer día.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-25" data-mp="15zzubakljycb">
          <Badge className="whitespace-nowrap" data-id="element-26" data-mp="110wqftgcry5x">✅ 100% Digital</Badge>
          <Badge className="whitespace-nowrap" data-id="element-27" data-mp="x032j02wujd1">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="3ltglflt1eim8">✨ 6 Tomos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-29" data-mp="3hrlm2muo2fb3">
          <Button type="button" size="md" className="w-full md:w-auto group" onClick={handlePurchaseClick} data-id="element-30" data-mp="3hq24msx9xy7q">
            <span className="group-hover:scale-110 transition-transform" data-id="element-31" data-mp="21by07aom32dz">
              QUIERO EMPEZAR A REGULAR MI SISTEMA NERVIOSO
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-32" data-mp="2686aa9nyc5ea" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-33" data-mp="2g02kuk785nze">
            <span className="flex items-center" data-id="element-34" data-mp="2kyn9rnh10l8j">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-35" data-mp="2l0zyqkl7bvv3">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-36" data-mp="2p1s8rg1we4sf">⚡ Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}